import React from 'react'
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'

const BetaVersionNotice = ({ show = true, isInModal = false }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  if (!show) return null

  return (
    <Box
      sx={{
        // Both fixed and absolute position can be used based on context
        position: isInModal ? 'sticky' : 'fixed',

        // Position it at the top left of the viewport or modal
        top: isSmallScreen ? 90 : 95,
        left: isSmallScreen ? 20 : 25,

        // Higher z-index in modal to appear above modal content
        zIndex: isInModal ? 1400 : 1000,

        // Styling for the notification - light blue background with blue text
        backgroundColor: 'rgba(173, 216, 230, 0.9)', // Light blue with transparency
        color: '#1976d2', // Blue text
        padding: {
          xs: '6px 12px',
          sm: '8px 16px',
        },
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        maxWidth: {
          xs: '100px',
          sm: '120px',
          md: '140px',
        },
        backdropFilter: 'blur(2px)',
        fontSize: {
          xs: '11px',
          sm: '12px',
          md: '14px',
        },
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.9,
        transition: 'opacity 0.3s ease',
        pointerEvents: 'none', // Ensures it doesn't interfere with clicks
        border: '1px solid rgba(25, 118, 210, 0.2)', // Subtle blue border
      }}
    >
      <Typography
        variant='body2'
        sx={{
          textAlign: 'center',
          fontSize: 'inherit',
          lineHeight: 1.3,
          fontWeight: 'inherit',
        }}
      >
        Beta Version
      </Typography>
    </Box>
  )
}

export default BetaVersionNotice
